import { Button } from "antd";
import WeaDialog from "../wea-dialog";
import WeaLocaleProvider from "../wea-locale-provider";
import WeaTable from "../wea-table";

const getLabel = WeaLocaleProvider.getLabel;
const columns = [
  {
    title: getLabel(15486, "序号"),
    dataIndex: "order",
    key: "order",
    width: 80,
    render: (record, text, index) => {
      return index + 1;
    }
  },
  {
    title: getLabel("23752", "附件名称"),
    dataIndex: "filename",
    key: "projectName"
  },
  {
    title: getLabel("531837", "含有的敏感词汇"),
    dataIndex: "sensitiveword",
    key: "sensitiveword"
  }
];
class SensitiveDialog extends React.Component {
  constructor(props) {
    super(props);
  }
  onEditCancel = () => {
    const { changeSensiVisible } = this.props;
    changeSensiVisible(false);
  };

  getBtn = () => {
    return [
      <Button type="primary" onClick={this.onEditCancel}>
        {getLabel(532049, "确定")}
      </Button>
    ];
  };

  render() {
    const { visible, sensitiveList = [] } = this.props;
    return (
      <WeaDialog
        className="wea-upload-sensitive"
        title={getLabel(531826, "附件敏感词预检提示")}
        icon="icon-coms02-Warning"
        iconBgcolor="#ff8e00"
        style={{ width: 600, height: 360 }}
        visible={visible}
        hasScroll={true}
        buttons={this.getBtn()}
        onCancel={this.onEditCancel}
      >
        <div className="wea-upload-sensitive-tip">
          {getLabel(
            "531836",
            "提示: 以下附件内容含有敏感词汇，请修改后重新上传！"
          )}
        </div>
        <WeaTable
          className="wea-upload-sensitive-table"
          columns={columns}
          dataSource={sensitiveList}
          pagination={false}
          bordered
        />
      </WeaDialog>
    );
  }
}

export default SensitiveDialog;



// WEBPACK FOOTER //
// ./ecology9/wea-upload/sensitiveDialog.js